import { axiosInstance } from '@/modules/shared/lib/axios';
import { PrintoutConfigurationPayload } from './types';

type Props = {
  companyId: string
  payload: PrintoutConfigurationPayload
}

export type UpdatePrintoutConfigurationResponse = {
  success: boolean
  data?: {
    message?: string
  }
}

export function updatePrintoutConfiguration({ companyId, payload }: Props) {
  return axiosInstance.post<UpdatePrintoutConfigurationResponse>(`/api/${companyId}/configuration/savePrintoutConfiguration`, payload);
}
